import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as actions from '../../actions'
import * as selectors from '../../selectors'

export type OwnProps = {
  payPalSettingId: number
  onClose: () => void
}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps) => {
  return {
    isLoading: selectors.isLoadingSelector(state, 'isUpdatePayPalSetting'),
    payPalSetting: selectors.payPalSettingSelector(state, ownProps.payPalSettingId)
  }
}

const mapDispatchToProps = {
  updatePayPalSetting: actions.updatePayPalSetting
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector>
